/**
 * THIS FILE IS IMPORTING BY block.js to build with webpack.wordpress.config.js and running on frontend
 */

import "./swiper";
